import WebMidi from 'webmidi'

export class MIDIAgent {
  constructor (defaultInputs = []) {
    // TODO: MIDI output interface
    this._WebMidi = WebMidi
    this.pressedNotes = new Set()
    this.sustainedNotes = new Set()
    this.sustainDown = false
    this.selectedInputs = defaultInputs
    this.initWebMidi()
  }

  nameOfSelectedInputs () {
    return this.selectedInputs.map(x => x.name)
  }

  dispatchUpdateNote (e) {
    const event = new CustomEvent('notes_update', {
      detail: {
        note: e.note,
        allNotes: this.allNotes(),
        sustainDown: this.sustainDown,
        pressedNotes: this.pressedNotes,
        sustainedNotes: this.sustainedNotes
      }
    })
    window.dispatchEvent(event)
    // console.info('notes_update')
  }

  initWebMidi () {
    WebMidi.enable(this.handler.bind(this))
  }

  handler (err) {
    if (err) {
      console.warn('WebMidi could not be enabled.', err)
    } else {
      this.setInputs(this.selectedInputs)
      console.log('WebMidi enabled!')
    }
  }

  setInputs (selected) {
    // Reset all listeners
    this.selectedInputs = selected
    for (let i = 0; i < WebMidi.inputs.length; i++) {
      WebMidi.inputs[i].removeListener()
    }

    // Check availability of inputs.
    if (WebMidi.inputs.length < 1) {
      console.warn('No Available Midi Input, WebMidi not initialized.')
      return
    }
    this.validInputs = []
    for (const inputToCheck of selected) {
      if (WebMidi.getInputByName(inputToCheck)) {
        this.validInputs.push(inputToCheck)
      } else {
        console.warn(`Name '${inputToCheck}' not found, thus considered invalid and omitted.`)
      }
    }
    if (this.validInputs.length < 1) {
      console.warn('No valid Midi Input, WebMidi not initialized.')
      return
    }
    // Update listeners
    for (const validInputName of this.validInputs) {
      const currentInput = WebMidi.getInputByName(validInputName)
      console.log(`current valid: ${validInputName}`)
      currentInput.addListener('noteon', 'all', this.noteOn.bind(this))
      currentInput.addListener('noteoff', 'all', this.noteOff.bind(this))
      currentInput.addListener('controlchange', 'all', this.controlChange.bind(this))
    }
  }

  noteOn (e) {
    const pitch = e.note.number
    this.pressedNotes.add(pitch)
    this.dispatchUpdateNote(e)
  }

  noteOff (e) {
    const pitch = e.note.number
    if (this.pressedNotes.has(pitch)) {
      this.pressedNotes.delete(pitch)
      if (this.sustainDown) {
        this.sustainedNotes.add(pitch)
      }
    }
    if (this.sustainedNotes.has(pitch) && !this.sustainDown) {
      this.sustainedNotes.delete(pitch)
    }
    this.dispatchUpdateNote(e)
  }

  controlChange (e) {
    const number = e.controller.number

    // sustain
    if (number === 64) {
      this.sustainDown = e.value > 64
    }
    if (!this.sustainDown) {
      this.sustainedNotes.clear()
    }

    this.dispatchUpdateNote(e)
  }

  allNotes () {
    const s = new Set(this.pressedNotes)
    for (const pitch of this.sustainedNotes) {
      s.add(pitch)
    }
    return s
  }
}
